export const C1 = 'c1';
export const C2 = 'c2';
export const C3 = 'c3';
export const C4 = 'c4';
export const C5 = 'c5';
export const C6 = 'c6'; // mobile
export const C7 = 'c7';
export const C8 = 'c8';
export const C9 = 'c9'; // desktop
export const C10 = 'c10';

export const SIZES = [C1, C2, C3, C4, C5, C6, C7, C8, C9, C10];

const isValidSize = (suffix) => {
    return SIZES.indexOf(suffix) !== -1;
};

const _getImageUrl = (imgUrl, size) => {
    const parts = imgUrl.split('.');
    let suffix = parts[parts.length - 2];

    if (isValidSize(suffix) && isValidSize(size)) {
        suffix = size;
        parts[parts.length - 2] = suffix;
        imgUrl = parts.join('.');
    }

    return imgUrl;
};

/**
 * @param {string} imgUrl - image url from odis
 * @param {string} size
 * @returns {string} new image url for specified size
 */
export const getImageUrl = (imgUrl, size = C6) => {
    if (!imgUrl || !imgUrl.length) {
        return null;
    }

    return _getImageUrl(imgUrl, size);
};


// WEBPACK FOOTER //
// ./src/universal/utils/images.js